"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherOwnerToJSON = exports.VoucherOwnerFromJSONTyped = exports.VoucherOwnerFromJSON = exports.instanceOfVoucherOwner = void 0;
/**
 * Check if a given object implements the VoucherOwner interface.
 */
function instanceOfVoucherOwner(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "entryCount" in value;
    return isInstance;
}
exports.instanceOfVoucherOwner = instanceOfVoucherOwner;
function VoucherOwnerFromJSON(json) {
    return VoucherOwnerFromJSONTyped(json, false);
}
exports.VoucherOwnerFromJSON = VoucherOwnerFromJSON;
function VoucherOwnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'entryCount': json['entryCount'],
    };
}
exports.VoucherOwnerFromJSONTyped = VoucherOwnerFromJSONTyped;
function VoucherOwnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'entryCount': value.entryCount,
    };
}
exports.VoucherOwnerToJSON = VoucherOwnerToJSON;
